<template>
  <a-modal v-model:open="isShowModal"
           title="修改密码"
           :width="480">
    <a-form ref="formRef"
            :model="formData"
            :rules="formRules"
            :labelCol="{style: { width: '80px' }}">
      <a-form-item label="原密码"
                   name="oldPassword">
        <a-input v-model:value.trim="formData.oldPassword" />
      </a-form-item>
      <a-form-item label="新密码"
                   name="password">
        <a-input v-model:value.trim="formData.password" />
      </a-form-item>
      <a-form-item label="确认密码"
                   name="confirmPassword">
        <a-input v-model:value.trim="formData.confirmPassword" />
      </a-form-item>
    </a-form>
    <template #footer>
      <a-button @click="closeModal">取消</a-button>
      <a-button type="primary"
                @click="onSubmit">
        确定
      </a-button>
    </template>
  </a-modal>
</template>

<script setup>
import { reactive, ref, watch } from 'vue';
import { message } from 'ant-design-vue';
import { employeeApi } from '@/api/employee.js';

const isShowModal = ref(false);

function showModal() {
  isShowModal.value = true;
}

function closeModal() {
  isShowModal.value = false;
}

watch(isShowModal, (newVal) => {
  if (!newVal) {
    Object.assign(formData, formDefault);
    formRef.value.resetFields();
  }
});

// =============================

const formDefault = {
  oldPassword: null,
  password: null,
  confirmPassword: null,
};

const formData = reactive({ ...formDefault });

function validateConfirmPwd(_rule, value) {
  if (!value) {
    return Promise.reject('请输入');
  }
  if (value !== formData.password) {
    return Promise.reject('两次密码输入不一致');
  }
  return Promise.resolve();
}

const formRules = {
  oldPassword: [{ required: true, message: '请输入' }],
  password: [{ required: true, message: '请输入' }],
  confirmPassword: [{ required: true, validator: validateConfirmPwd }],
};

// ==============================

const formRef = ref();

function onSubmit() {
  formRef.value
    .validate()
    .then(() => {
      updatePwd();
    })
    .catch(() => {});
}

async function updatePwd() {
  try {
    await employeeApi.updatePwd(formData);
    message.success('修改成功');
    closeModal();
  } catch (err) {
    console.log(err);
  }
}

// 暴露==========================
defineExpose({
  showModal,
  closeModal,
});
</script>

<style lang='less' scoped>
</style>